import React from 'react';
import AdminPage from './Admin';  // Import AdminPage Component
import ExpenseCategory from './Adminpageretrival';  // Import ExpenseCategory Component
import './adminfrontend.css';  // Import the corresponding CSS file

function CombinedPage() {
  return (
    <div className="combinedpage-front-end-container">
      <h1 className="combinedpage-front-end-header">Admin Frontend</h1>
      <div className="combinedpage-pages-container">
        <div className="combinedpage-page">
          <AdminPage />
        </div>
        <div className="combinedpage-page">
          <ExpenseCategory />
        </div>
      </div>
    </div>
  );
}

export default CombinedPage;
